import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { AuthResponse, User } from '../models/api.models';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private readonly api: ApiService,
    private readonly storage: StorageService
  ) {}

  register(payload: Record<string, string>): Observable<AuthResponse> {
    return this.api.post<AuthResponse>('/auth/register', payload).pipe(
      tap((response) => this.persistSession(response))
    );
  }

  login(payload: Record<string, string>): Observable<AuthResponse> {
    return this.api.post<AuthResponse>('/auth/login', payload).pipe(
      tap((response) => this.persistSession(response))
    );
  }

  logout(): void {
    this.storage.clearAll();
  }

  currentUser(): User | null {
    return this.storage.getUser<User>();
  }

  isAuthenticated(): boolean {
    return Boolean(this.storage.getToken());
  }

  private persistSession(response: AuthResponse): void {
    this.storage.setToken(response.token);
    this.storage.setUser(response.user);
  }
}
